import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { AccountWallModels } from '@models/account-wall.model';

@Injectable({ providedIn: 'root' })
export class AccountWallService {
  constructor(private http: HttpClient) {}

  public getAllWallsForAccount(
    accountId: string,
    filters: AccountWallModels.QueryParamFilters,
    latestTs: number | null,
  ): Observable<AccountWallModels.WallWithAssignment[]> {
    let params = new HttpParams();
    params = params.set('limit', AccountWallModels.PAGE_LIMIT.toString());
    if (filters.query) params = params.set('query', filters.query);
    if (filters.cameraIdsIncludes?.length)
      params = params.set('cameraIdsIncludes', filters.cameraIdsIncludes.join(','));
    if (filters.tagIds) params = params.set('tagIds', filters.tagIds);
    if (latestTs !== null) params = params.set('latestTs', latestTs.toString());
    return this.http.get<AccountWallModels.WallWithAssignment[]>(
      api.accountWalls.getAllWalls(accountId),
      { params },
    );
  }

  public addWallToAccount(accountId: string, wallId: string): Observable<void> {
    return this.http.post<void>(api.accountWalls.addWallToAccount(accountId), {
      wallId,
    });
  }

  public removeWallFromAccount(accountId: string, wallId: string): Observable<void> {
    return this.http.delete<void>(
      api.accountWalls.removeWallFromAccount(accountId, wallId),
    );
  }
}
